import { LIMITS } from '@cardengine/shared';
import { useEffect, useRef, useState } from 'react';
import { useStore } from '../store.js';

export function Chat() {
  const chat = useStore((s) => s.chat);
  const sendChat = useStore((s) => s.sendChat);
  const [draft, setDraft] = useState('');
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const list = listRef.current;
    if (list) list.scrollTop = list.scrollHeight;
  }, [chat.length]);

  return (
    <section className="chat" aria-label="Table chat">
      <div className="chat__log" ref={listRef}>
        {chat.length === 0 && <p className="chat__empty">Say hello.</p>}
        {chat.map((message) => (
          <p key={message.id} className={`chat__line ${message.system ? 'chat__line--system' : ''}`}>
            {!message.system && <span className="chat__author">{message.name}</span>}
            <span className="chat__text">{message.text}</span>
          </p>
        ))}
      </div>

      <form
        className="chat__form"
        onSubmit={(event) => {
          event.preventDefault();
          const text = draft.trim();
          if (!text) return;
          sendChat(text);
          setDraft('');
        }}
      >
        <input
          className="chat__input"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          placeholder="Message the table"
          maxLength={LIMITS.chatMax}
          aria-label="Chat message"
        />
        <button type="submit" className="btn btn--ghost btn--small" disabled={!draft.trim()}>
          Send
        </button>
      </form>
    </section>
  );
}
